// BottomMenu.tsx
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MenuIcon from '@mui/icons-material/WidgetsTwoTone';
import styles from './BottomMenu.module.css';

export const BottomMenu = () => {


  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        <Link to="/" className={styles.navItem}>
          <HomeIcon fontSize="large" />
          <span>Главное</span>
        </Link>
        
        <Link to="/services" className={styles.navItem}>
          <MenuIcon fontSize="large" />
          <span>Услуги</span>
        </Link>
        


        <Link to="/card" className={styles.navItem}>
          <ShoppingCartIcon fontSize="large" />
          <span>Корзина</span>
        </Link>
      </nav>
    </div>
  );
};